// src/firebase.ts
import { initializeApp, FirebaseApp, getApps } from "firebase/app";
import { getAuth, Auth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore, Firestore } from "firebase/firestore";
import { getStorage, FirebaseStorage } from "firebase/storage";

// Determine authDomain based on environment
// For local development, use localhost or local domain
// For local IP addresses, Firebase doesn't support them - use local domain instead
// Note: Firebase Auth does NOT support IP addresses directly
const getAuthDomain = (): string => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    // For actual localhost, use the Firebase project's default auth domain
    // This ensures redirect URLs are constructed correctly (with proper port handling)
    // Note: 'localhost' must still be in authorized domains in Firebase Console
    // The authDomain here is just for constructing redirect URLs - the actual origin check uses authorized domains
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      // Use Firebase project's default domain for proper redirect URL construction
      // This allows Firebase to properly handle the OAuth callback
      return 'budget-trace.firebaseapp.com';
    }
    // For .local domains (e.g., budget-trace.local), note that Google OAuth
    // does NOT support .local domains - they must use a public TLD.
    // Use localhost instead for OAuth to work.
    if (hostname.endsWith('.local')) {
      console.warn('⚠️ .local domains do NOT work with Google OAuth. Use localhost instead. See docs/LOCAL_DEV_SETUP.md');
      return hostname; // Use the .local domain directly (but OAuth won't work)
    }
    // For local IP addresses, Firebase doesn't support them
    // User should set up a local domain (see docs/LOCAL_DOMAIN_SETUP.md)
    if (
      hostname.match(/^192\.168\./) ||
      hostname.match(/^10\./) ||
      hostname.match(/^172\.(1[6-9]|2[0-9]|3[01])\./)
    ) {
      // Try to use default Firebase domain, but this will likely fail
      // Recommend using local domain instead
      console.warn('⚠️ Using IP address - Firebase Auth may not work. Consider setting up a local domain (budget-trace.local). See docs/LOCAL_DOMAIN_SETUP.md');
      return 'budget-trace.firebaseapp.com';
    }
  }
  // Production: use custom domain
  return 'budgettrace.io';
};

const firebaseConfig = {
  apiKey: "AIzaSyBMw-9Ml13t7IpYcSfpDI8coHWbr8IV15o",
  authDomain: getAuthDomain(),
  projectId: "budget-trace",
  storageBucket: "budget-trace.firebasestorage.app",
  messagingSenderId: "718937684294",
  appId: "1:718937684294:web:7f3e3b828a55f42596cd47"
};

// Initialize app only if it hasn't been initialized yet (prevents errors during HMR)
let app: FirebaseApp;
const apps = getApps();
if (apps.length === 0) {
  app = initializeApp(firebaseConfig);
} else {
  app = apps[0];
}

// Initialize Firebase services
const auth: Auth = getAuth(app);
const provider: GoogleAuthProvider = new GoogleAuthProvider();
const db: Firestore = getFirestore(app);
const storage: FirebaseStorage = getStorage(app);

// Export after initialization to ensure proper order
export { auth, provider, db, storage };
